<script setup>
import { ref, toRefs, watch } from "vue";
import * as amplitude from "@amplitude/analytics-browser";
import Modal from "@/components/Modal.vue";

const props = defineProps({
  visible: Boolean,
  toggle: Function
});

const { visible } = toRefs(props);
const isVisible = ref(visible);

watch(visible, () => {
  isVisible.value = visible.value;
});

function goToPhotoAuth() {
  amplitude.track("Select go to photo auth");
  window.location.href = `${window.location.origin}/${import.meta.env.VITE_PHOTO_AUTH_PREFIX}${window.location.search}`;
}
</script>

<template>
<Modal v-if="isVisible" @close="toggle()">
  <template #title>
    {{ $t("photo_auth") }}
  </template>
  <template #description>
    {{ $t("take_photo") }}
  </template>
  <template #footer>
    <button class="text-center text-lg text-[var(--secondary)]" @click="goToPhotoAuth()">
      {{ $t("btn_photo_auth") }}
    </button>
  </template>
</Modal>
</template>
